import { constants } from "@thecb/components";

const { CHARADE_GREY, SEA_GREEN } = constants.colors;

const textColor = `${CHARADE_GREY}`;
const autopayTextColor = `${SEA_GREEN}`;

export const fallbackValues = {
  textColor,
  autopayTextColor
};
